module.exports = require('../dist/drivers/mortgages');

